import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'moment'
})
export class MomentPipe implements PipeTransform {

    transform( value: any, arg?: any ): any {
        moment.locale('pt-BR');

        if (arg == 'relative') {
            return moment(value).fromNow();
          } else if ( arg == 'complete') {
            return moment(value).format('L HH:mm');
          }

          return moment(value).format('HH:mm');

    }

}